/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Box from 'components/ui/box';
import ReactModal from 'react-modal';
import { useEffect, useRef, useState } from 'react';
import { TbSearch } from 'react-icons/tb';
import { findPlayer } from 'services/profile.service';
import { User } from 'types/user';
import { RiCloseLine } from 'react-icons/ri';
import { IoMdCloseCircle } from 'react-icons/io';
import { useAuth } from 'context/AuthContext';
import { Colaboracao, FocoNoCliente, Inovacao, MandouBem, Resolutividade, Lideranca, Uau, Valeu } from 'components/icons';
import { actionLog, pushPlayerAction, registerRewardBehavior, verifySentPoints } from 'services/actionlog.service';
import { BehaviorLabel, GetBehaviorDescription, GetBehaviorLabel, GetMoedaDescription, GetMoedaLabel } from 'utils/strings';
import { BsTrash } from 'react-icons/bs';

import './style.scss';
import { UserAvatar } from 'components/user-avatar';

import FeedbackGeral from 'assets/img/comportamento/bg-feedback-moedas.png';
import FeedbackMandou from 'assets/img/comportamento/mandou.svg';
import FeedbackUau from 'assets/img/comportamento/uau.svg';
import FeedbackValeu from 'assets/img/comportamento/valeu.svg';
import {
  getPlayerInfo,
  getServerTime,
  sendPreferenceNotification,
  sendPartialRecognition,
  getPartialRecognition,
} from 'services/dashboard.service';
import TextEditor from 'components/text-editor';
import { AiOutlineWarning } from 'react-icons/ai';
import Modal from './Modal/Index';
import { BiInfoCircle } from 'react-icons/bi';
import { convertEmojis } from 'utils/helpers';
import Tippy from '@tippyjs/react';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';
import ModalAcessivel from 'components/modal-acessivel';
import ModalAlert from './ModalAlert';
import PointsPicker from './components/points-picker';
import {
  CoinKey,
  ceilingFor,
  coinIsAvailable,
  coinUnavailableReason,
  hasAnyRecognitionAvailable,
  isCoinKey,
  isValidPoints,
  optionState,
} from './recognition-points';

const maskTemplate = 'F9999999';

export default function Reconhecer() {
  const navigate = useNavigate();
  const params = useParams();
  const pearsonRef = useRef<HTMLDivElement>(null);
  const behaviorRef = useRef<HTMLDivElement>(null);
  const recognitionRef = useRef<HTMLDivElement>(null);
  const feedbackRef = useRef<HTMLDivElement>(null);
  const sendedRef = useRef<HTMLDivElement>(null);
  const feedbackServer = useRef<HTMLDivElement>(null);

  const { user, userInfo, refreshUser, currentCycle } = useAuth();
  const { showModal, closeModal } = useModal();
  const { helpData } = useHelp();

  const searchRef = useRef<any>();
  const noResultsRef = useRef<any>();
  const resultsRef = useRef<any>();

  const [isOpen, setIsOpen] = useState(true);

  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [searched, setSearched] = useState(false);
  const [target, setTarget] = useState<User>();
  const [behavior, setBehavior] = useState<string>();
  const [coin, setCoin] = useState<CoinKey | undefined>();
  const [points, setPoints] = useState<number | undefined>();
  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [playerInfo, setPlayerInfo] = useState<any>({});
  const [showModalItem, setshowModalItemItem] = useState(false);

  const [step, setStep] = useState(0);

  const [submitMessage, setSubmitMessage] = useState<string | undefined>();
  const [hasSubmitError, setHasSubmitError] = useState<boolean>(false);
  const [usersNotificationPreference, setUsersNotificationPreference] = useState<string[]>([]);
  const [showModalAlert, setShowModalAlert] = useState<any>(false);
  const [modalAlertHtml, setModalAlertHtml] = useState<string | undefined>();
  const [isWarning, setIsWarning] = useState<boolean>(false);
  const [cacheMessage, setCacheMessage] = useState<string>('');

  const [pointsSent, setPointsSent] = useState<number>(0);

  const balance = user?.point_categories?.point_behavior || 0;

  const [mask, setMask] = useState('');

  // Partial recognition states
  const [isLoadingPartialRecognition, setIsLoadingPartialRecognition] = useState(false);
  const [hasPartialRecognition, setHasPartialRecognition] = useState(false);
  const [isRecoveredDraft, setIsRecoveredDraft] = useState(false);
  const savePartialRecognitionTimerRef = useRef<NodeJS.Timeout | null>(null);

  /* Última pessoa já conferida no servidor. A conferência normalmente roda na escolha
     (etapa 0) e na revisão (etapa 4), mas um rascunho recuperado devolve pessoa e etapa
     no MESMO render — e se a etapa salva for 1, 2 ou 3 nenhuma das duas condições vale.
     Guardando quem já foi conferido, a pessoa restaurada é checada uma vez, e a navegação
     normal entre as etapas continua sem chamada nova. */
  const verifiedTargetRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const close = (e: any) => {
      if (e.keyCode === 27) {
        handleCloseModal();
      }
      console.log(e.keyCode);
    };
    window.addEventListener('keydown', close);

    return () => window.removeEventListener('keydown', close);
  }, []);

  useEffect(() => {
    if (!!pearsonRef && pearsonRef.current) {
      setTimeout(() => {
        pearsonRef?.current?.querySelector('h2')?.focus();
      }, 300);
    }
    if (!!behaviorRef && !!behaviorRef.current) {
      setTimeout(() => {
        behaviorRef?.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!recognitionRef && !!recognitionRef.current) {
      setTimeout(() => {
        recognitionRef.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!feedbackRef && !!feedbackRef.current) {
      setTimeout(() => {
        feedbackRef.current?.querySelector('h2')?.focus();
      }, 300);
    }

    if (!!sendedRef && !!sendedRef.current) {
      setTimeout(() => {
        sendedRef.current?.querySelector('a')?.focus();
      }, 300);
    }
  }, [step]);

  const minTextLength = 50;

  const maxTextLength = 600;

  ReactModal.setAppElement('#modal');

  const iconSize = 16;
  const Coins: any = {
    uau: (
      <div className="w-[16px]">
        <Uau size={iconSize} />
      </div>
    ),
    mandou: (
      <div className="w-[16px]">
        <MandouBem size={iconSize} />
      </div>
    ),
    valeu: (
      <div className="w-[16px]">
        <Valeu size={iconSize} />
      </div>
    ),
  };

  const CoinLabel: any = {
    uau: '#UAU',
    mandou: '#MANDOUBEM',
    valeu: '#VALEU',
  };

  const Behaviors: any = {
    colaboracao: (
      <div className="w-[16px]">
        <Colaboracao size={iconSize} />
      </div>
    ),
    inovacao: (
      <div className="w-[16px]">
        <Inovacao size={iconSize} />
      </div>
    ),
    foco: (
      <div className="w-[16px]">
        <FocoNoCliente size={iconSize} />
      </div>
    ),
    resolutividade: (
      <div className="w-[16px]">
        <Resolutividade size={iconSize} />
      </div>
    ),
    lideranca: (
      <div className="w-[16px]">
        <Lideranca size={iconSize} />
      </div>
    ),
  };

  function sendPartialLog(action: any) {
    try {
      const obj = {
        action: !!action ? action : 'ND',
        step,
        hasEnoughCoins: {
          uau: coinIsAvailable('uau', balance, pointsSent),
          mandou: coinIsAvailable('mandou', balance, pointsSent),
          valeu: coinIsAvailable('valeu', balance, pointsSent),
          point_behavior: user?.point_categories?.point_behavior ? user?.point_categories?.point_behavior : 'ND',
        },
        loading: !!loading,
        target: !!target && target._id ? target._id : 'ND',
        behavior: !!behavior ? behavior : 'ND',
        coin: !!coin ? coin : 'ND',
        points: points !== undefined ? points : 'ND',
        pointsSent,
        message: !!message ? message : 'ND',
        messageLength: !!messageLength ? messageLength : 'ND',
        minTextLength: !!minTextLength ? minTextLength : 'ND',
        maxTextLength: !!maxTextLength ? maxTextLength : 'ND',
        stage: {
          status: currentCycle && currentCycle.status ? currentCycle?.status : 'ND',
          date_start:
            currentCycle && currentCycle.date_start
              ? typeof currentCycle.date_start === 'number'
                ? { $date: currentCycle.date_start }
                : currentCycle.date_start
              : 'ND',
          date_finish:
            currentCycle && currentCycle.date_finish
              ? typeof currentCycle.date_finish === 'number'
                ? { $date: currentCycle.date_finish }
                : currentCycle.date_finish
              : 'ND',
        },
      };

      pushPlayerAction('partialRewardBehavior', {
        data: obj,
      });
    } catch (error) {}
  }

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  /*
   * Ponto único de entrada do aviso desta tela. O texto formatado é opcional, e
   * hoje só o bloqueio por grupo restrito o envia.
   *
   * Existe para que as duas partes do aviso andem SEMPRE juntas: como o mesmo
   * modal atende cinco situações diferentes, definir só o texto deixaria o HTML
   * do aviso anterior na tela, casando a formatação de um com o texto de outro.
   */
  function exibirAlerta(texto: string, textoFormatado?: string) {
    setModalAlertHtml(textoFormatado);
    setShowModalAlert(texto);
  }

  async function handleSearch(e?: any) {
    if (e) {
      e.preventDefault();
    }

    sendPartialLog({ type: 'search', data: searchRef?.current?.value });

    try {
      const matricula = searchRef.current.value.replace('_', '');

      if (!matricula || matricula === user?._id) {
        return;
      }

      setSearching(true);
      const result = await findPlayer(searchRef.current.value);
      const filteredResults = result.filter((item: any) => item._id !== user?._id);
      if (filteredResults.length === 1) {
        setTarget(filteredResults[0]);
      } else {
        setSearchResults(filteredResults);

        setIsEmpty(filteredResults?.length === 0 && matricula.startsWith('F') && matricula.slice(1).match(/^[0-9]+$/) != null);
      }
      setSearching(false);
      setSearched(true);

      if (filteredResults.length === 0) {
        afterNoResultSearch();
      } else {
        resultsRef.current?.focus();
      }
    } catch (e) {
      setSearching(false);
    }
  }

  /**
   * Trocar de categoria SEMPRE descarta o valor escolhido: as faixas nao se
   * sobrepoem, entao um valor de #UAU nunca e valido em #MANDOUBEM. Concentrado
   * num handler unico para nao depender de disciplina nos call-sites — o markup
   * da etapa 3 e duplicado entre desktop e mobile.
   */
  function selectCoin(nextCoin: CoinKey) {
    sendPartialLog({ type: 'setCoin', data: nextCoin });

    setCoin(nextCoin);
    setPoints(undefined);
  }

  function selectPoints(value: number) {
    sendPartialLog({ type: 'setPoints', data: value });

    setPoints(value);
  }

  async function handleSubmit() {
    sendPartialLog({ type: 'handleSubmit' });

    try {
      if (
        loading ||
        !target ||
        !behavior ||
        !coin ||
        !points ||
        !message ||
        !messageLength ||
        messageLength.textLength < minTextLength ||
        messageLength.fullLength > maxTextLength
      )
        return;

      setLoading(true);

      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        return toast.error(`Não há fase disponível para envio de reconhecimentos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      const log = await registerRewardBehavior('me', 'reward_behavior', {
        target: target?._id,
        behavior,
        coin,
        points,
        message,
      });

      setLoading(false);
      setSubmitted(true);
      refreshUser();

      if (log && log.attributes.status && log.attributes.status !== 'OK') {
        setHasSubmitError(true);

        if (!!log?.attributes?.systemMessage) {
          setSubmitMessage(log?.attributes?.systemMessage);
        } else {
          setSubmitMessage('Ocorreu um erro com a sua solicitação. Por favor, tente novamente em alguns minutos.');
        }
      } else if (log && log.attributes.status && log.attributes.status === 'OK') {
        setHasSubmitError(false);

        // Clear partial recognition on success
        clearPartialRecognition();

        if (!!log?.attributes?.systemMessage) {
          setSubmitMessage(log?.attributes?.systemMessage);
        } else {
          setSubmitMessage(
            'Você reconheceu um colega. Agradecemos por ajudar a tornar o BB um ambiente colaborativo e agradável para trabalhar.',
          );
        }
      }
    } catch (e) {
      setLoading(false);
      setSubmitted(true);
      refreshUser();
      setSubmitMessage('Ocorreu um erro com a sua solicitação. Por favor, tente novamente em alguns minutos.');
      setHasSubmitError(true);
    }

    if (!!feedbackServer && !!feedbackServer.current) {
      setTimeout(() => {
        feedbackServer.current?.querySelector('h1')?.focus();
      }, 300);
    }
  }

  async function savePartialRecognition(updates?: {
    step?: number;
    target?: User;
    behavior?: string;
    coin?: string;
    points?: number;
    message?: string;
  }) {
    if (isLoadingPartialRecognition || !user?._id) {
      return;
    }

    try {
      const currentStep = updates?.step !== undefined ? updates.step : step;
      const currentTarget = updates?.target !== undefined ? updates.target : target;
      const currentBehavior = updates?.behavior !== undefined ? updates.behavior : behavior;
      const currentCoin = updates?.coin !== undefined ? updates.coin : coin;
      const currentPoints = updates?.points !== undefined ? updates.points : points;
      const currentMessage = updates?.message !== undefined ? updates.message : message;

      const partialRecognition: any = {
        _id: user._id,
        step: currentStep,
      };

      if (currentTarget?._id) {
        partialRecognition.target = currentTarget._id;
      }

      if (currentBehavior) {
        partialRecognition.behavior = currentBehavior;
      }

      if (currentCoin) {
        partialRecognition.coin = currentCoin;
      }

      if (currentPoints) {
        partialRecognition.points = currentPoints;
      }

      if (currentMessage) {
        partialRecognition.message = currentMessage;
      }

      // Only save if there's meaningful data
      if (Object.keys(partialRecognition).length > 1) {
        await sendPartialRecognition(partialRecognition);
        setHasPartialRecognition(true);
      }
    } catch (error) {
      console.error('Erro ao salvar reconhecimento parcial:', error);
    }
  }

  function debouncedSavePartialRecognition(
    updates?: {
      step?: number;
      target?: User;
      behavior?: string;
      coin?: string;
      points?: number;
      message?: string;
    },
    delay = 50,
  ) {
    if (savePartialRecognitionTimerRef.current) {
      clearTimeout(savePartialRecognitionTimerRef.current);
    }

    savePartialRecognitionTimerRef.current = setTimeout(() => {
      savePartialRecognition(updates);
      savePartialRecognitionTimerRef.current = null;
    }, delay);
  }

  async function clearPartialRecognition() {
    try {
      if (savePartialRecognitionTimerRef.current) {
        clearTimeout(savePartialRecognitionTimerRef.current);
        savePartialRecognitionTimerRef.current = null;
      }
      // Send only _id to clear the record
      await sendPartialRecognition(user?._id ? { _id: user._id } : null);
      setHasPartialRecognition(false);
      document.dispatchEvent(new CustomEvent('reload:partialRecognition'));
    } catch (error) {
      console.error('Erro ao limpar reconhecimento parcial:', error);
    }
  }

  function reset() {
    setTarget(undefined);
    setBehavior(undefined);
    setCoin(undefined);
    setPoints(undefined);
    setSubmitted(false);
    setLoading(false);
    setSubmitMessage(undefined);
    setHasSubmitError(false);
    setSearchResults([]);
    setSearching(false);
    setMessage(undefined);
    setMessageLength(undefined);
    setStep(0);
  }

  function handleCloseModal() {
    // Notify Dashboard to update partial recognition status
    document.dispatchEvent(new CustomEvent('reload:partialRecognition'));
    reset();
    navigate('../');
  }

  const getImgFeedback = (_coin: string) => {
    const imgs: any = {
      mandou: FeedbackMandou,
      uau: FeedbackUau,
      valeu: FeedbackValeu,
      geral: FeedbackGeral,
    };

    return imgs[_coin || 'geral'];
  };

  /**
   * Rotulo da pill do card da categoria. Com a fracionacao o card nao anuncia
   * mais um valor fechado: ele anuncia o TETO da faixa, e o valor o jogador
   * escolhe logo abaixo, no seletor de pontos.
   */
  function coinCapLabel(coin_type: CoinKey) {
    switch (coinUnavailableReason(coin_type, balance, pointsSent)) {
      case 'no-balance':
        return 'Saldo insuficiente';
      case 'over-limit':
        return 'Limite atingido';
      default:
        return `Até ${ceilingFor(coin_type)} pontos`;
    }
  }

  function coinIsBlocked(coin_type: CoinKey) {
    return !coinIsAvailable(coin_type, balance, pointsSent);
  }

  function focusOnElement(selector: string) {
    const element: any = document.querySelector(selector);
    setTimeout(() => {
      if (!!element) {
        element?.focus();
      }
    }, 500);
  }

  function afterOpenModal() {
    focusOnElement('.modal-reconhecer h1');
  }

  function afterNoResultSearch() {
    focusOnElement('.noResult div');
  }

  function handleChangeMessage(content: string, contentLength: any) {
    setMessage(content);
    setMessageLength(contentLength);
  }

  useEffect(() => {
    async function playerCanView() {
      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        toast.error(`Não há fase disponível para envio de reconhecimentos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        return navigate('/');
      }

      const data = await getPlayerInfo(user?._id);
      setPlayerInfo(data);
    }

    if (!!currentCycle) {
      playerCanView();
    }
  }, [currentCycle, navigate]);

  // Load partial recognition on mount
  useEffect(() => {
    async function loadPartialRecognition() {
      if (params?.id) return; // Don't load if there's an ID in params (direct search)

      try {
        setIsLoadingPartialRecognition(true);
        const partialData = await getPartialRecognition();

        // Only consider it a recovered draft if there's meaningful data (not just an empty object)
        const hasMeaningfulData =
          partialData &&
          (partialData.target ||
            partialData.behavior ||
            partialData.coin ||
            partialData.message ||
            (typeof partialData.step === 'number' && partialData.step > 0));

        if (hasMeaningfulData) {
          setHasPartialRecognition(true);
          setIsRecoveredDraft(true);

          // Load target if exists
          if (partialData.target) {
            const playerData = await findPlayer(partialData.target, true);
            if (playerData && playerData.length) {
              setTarget(playerData[0]);
            }
          }

          // Load behavior if exists
          if (partialData.behavior) {
            setBehavior(partialData.behavior);
          }

          // Load coin if exists
          const savedCoin = isCoinKey(partialData.coin) ? partialData.coin : undefined;

          if (savedCoin) {
            setCoin(savedCoin);
          }

          /**
           * O valor so volta se ainda pertencer a faixa da moeda salva. Saldo e
           * limite sao reavaliados depois, quando `pointsSent` chega do backend
           * — e la que mora o resto do descarte.
           */
          const savedPoints = typeof partialData.points === 'number' ? partialData.points : undefined;
          const pointsStillValid = !!savedCoin && savedPoints !== undefined && isValidPoints(savedCoin, savedPoints);

          if (pointsStillValid) {
            setPoints(savedPoints);
          }

          // Load message if exists
          if (partialData.message) {
            setMessage(partialData.message);
            // Calculate messageLength from saved message
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = partialData.message;
            const textContent = tempDiv.textContent || tempDiv.innerText || '';
            setMessageLength({
              textLength: textContent.length,
              fullLength: partialData.message.length,
            });
          }

          // Resume at saved step
          if (typeof partialData.step === 'number') {
            const savedStep = partialData.step;

            // Sem valor valido nao ha o que revisar nem enviar: volta para a
            // etapa em que o valor e escolhido.
            setStep(savedStep > 2 && !pointsStillValid ? 2 : savedStep);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar reconhecimento parcial:', error);
      } finally {
        setIsLoadingPartialRecognition(false);
      }
    }

    loadPartialRecognition();
  }, []);

  /**
   * Um valor escolhido pode deixar de ser valido depois que o `pointsSent`
   * chega do backend (o jogador ja mandou pontos para essa pessoa nesta fase)
   * ou que o saldo e atualizado por `refreshUser`.
   */
  useEffect(() => {
    if (!coin || points === undefined) {
      return;
    }

    if (optionState(coin, points, balance, pointsSent) !== 'enabled') {
      setPoints(undefined);

      // Nao da para revisar nem enviar sem valor: volta para a etapa da escolha.
      if (step > 2) {
        setStep(2);
      }
    }
  }, [coin, points, balance, pointsSent, step]);

  // Auto-save partial recognition when fields change
  useEffect(() => {
    // Don't save if we're loading, submitted, or there's no meaningful data
    if (isLoadingPartialRecognition || submitted || (!target && !behavior && !coin && !message)) {
      return;
    }

    // Never save on step 0 - only start saving from step 1 onwards
    if (step === 0) {
      return;
    }

    // Save with debounce when any field changes
    debouncedSavePartialRecognition({ step, target, behavior, coin, points, message });

    // Cleanup timer on unmount
    return () => {
      if (savePartialRecognitionTimerRef.current) {
        clearTimeout(savePartialRecognitionTimerRef.current);
      }
    };
  }, [step, target, behavior, coin, points, message, isLoadingPartialRecognition, submitted]);

  useEffect(() => {
    setTimeout(() => {
      if (!searching && searchRef && searchRef.current && params && params.id) {
        searchRef.current.value = params.id;
        handleSearch();
      }
    }, 1000);
  }, [params]);

  useEffect(() => {
    if (
      !!target &&
      !!playerInfo &&
      Array.isArray(playerInfo.relacionamentos) &&
      !!playerInfo?.relacionamentos?.find((item: any) => item === target.extra.id)
    ) {
      setshowModalItemItem(true);
    }

    if (target && target?.extra?.recognition === false) {
      if (
        !usersNotificationPreference ||
        !usersNotificationPreference.length ||
        !usersNotificationPreference?.find((e: string) => e === target._id)
      ) {
        setUsersNotificationPreference([...usersNotificationPreference, target._id]);

        const payload = {
          target: target._id,
          user: user?._id,
          item: 'recognition',
          created: { $date: new Date().getTime() },
        };

        sendPreferenceNotification(payload);
      }
      exibirAlerta(`${target?.extra?.nome_guerra} optou, em "Minhas Preferências", pela não participação nesta dinâmica.`);
      setTarget(undefined);
    }

    async function verifyPointsSent() {
      setIsWarning(false);

      const pessoaAindaNaoConferida = !!target && verifiedTargetRef.current !== target._id;

      if (!!target && playerInfo?._id && (step === 0 || step === 4 || pessoaAindaNaoConferida)) {
        verifiedTargetRef.current = target._id;

        const resp = await verifySentPoints(playerInfo?._id, target._id, message);

        /* Grupo restrito (Auditoria Interna, Controles Internos, Riscos): antecipa aqui o
           mesmo bloqueio que o servidor aplica no envio, para a pessoa não escrever o
           reconhecimento à toa. A busca continua encontrando todo mundo — o que muda é só
           o que acontece ao escolher. Quem decide é sempre o servidor: se a verificação
           falhar, o envio segue e o trigger recusa com a mesma mensagem. */
        if (resp?.group_blocked) {
          setPointsSent(0);
          setCacheMessage('');
          setTarget(undefined);
          /* Único aviso da tela com texto formatado. `message_html` só vem quando o grupo
             tem a versão rica cadastrada no Studio; sem ela, cai no texto puro de sempre. */
          exibirAlerta(resp.message, resp.message_html);
          return;
        }

        if (step === 0 && resp && resp?.points_sent_total && resp.points_sent_total > 0) {
          setPointsSent(resp.points_sent_total || 0);
          setIsWarning(true);
          setCacheMessage(resp.message);

          if (resp?.limit_reached) {
            setIsWarning(false);
            setTarget(undefined);
            exibirAlerta(resp.message);
          }
        } else if (step === 0) {
          setPointsSent(0);
          setCacheMessage('');
        }

        if (step === 4 && message && resp?.message_already_sent) {
          exibirAlerta(resp.message);
          setStep(3);
        }
      }

      if (step === 2 && cacheMessage) {
        setIsWarning(true);
        exibirAlerta(cacheMessage);
      }
    }

    verifyPointsSent();
  }, [target, playerInfo, step]);

  function showRetryButton() {
    if (submitMessage) {
      switch (submitMessage) {
        case 'Não existe fase aberta para envio de reconhecimento.':
          return false;
        case 'Você não possui saldo suficiente para reconhecer. Por favor, aguarde até a próxima distribuição.':
          return false;
        case 'Você já enviou o limite máximo de 300 pontos, para a mesma pessoa, neste mês.':
          return false;
        case 'Você não pode emitir reconhecimentos. Em caso de dúvidas, entre em contato com nossa equipe.':
          return false;
        case 'Você já fez esse reconhecimento ao mesmo usuário nesta fase.':
          return false;
        default:
          return true;
      }
    }
  }

  if (user?.extra?.recognition === false || !!playerInfo?.visualizador) return null;

  return (
    <ReactModal
      key={'modal-reconhecer'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Reconhecer"
      portalClassName="modal-reconhecer"
      overlayClassName="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center overflow-hidden"
      contentElement={() => (
        <ModalAcessivel isOpen={isOpen} onRequestClose={closeModal}>
          {!submitted && (
            <Box className="relative bg-oxford-blue border-electric-blue p-1 lg:p-8 flex flex-col w-[90%] lg:max-w-screen-md justify-center items-center border-opacity-100 bg-opacity-100">
              <div className="flex justify-center items-center space-x-2 mb-3 mx-8">
                <h1
                  className="text-xl mt-4 lg:mt-0 lg:text-lg block text-center text-yellow"
                  tabIndex={0}
                  aria-label="Reconheça quem Joga Junto"
                >
                  Reconheça quem #JogaJunto!
                </h1>
              </div>

              {!!helpData && (
                <div className="mx-8 mb-5">
                  <p>
                    Possui dúvidas para enviar reconhecimento? Confira o tutorial em vídeo.
                    <button
                      aria-label="Reconheça quem Joga Junto"
                      className="p-2 text-[#C2D2FF]"
                      onClick={() => showModal('help-video')}
                    >
                      ASSISTIR VÍDEO
                    </button>
                  </p>
                </div>
              )}
              <button
                className="absolute -top-5 -right-5 button-close"
                tabIndex={0}
                aria-label="Fechar modal ”Reconhecer colega”. Voltar para tela inicial"
                onClick={() => {
                  if (searchResults.length > 0) {
                    sendPartialLog({ type: 'close', location: 'header', reset: true });
                    reset();
                  } else {
                    sendPartialLog({ type: 'close', location: 'header', reset: false });
                    setIsOpen(false);
                  }
                }}
              >
                <IoMdCloseCircle size={48} className="text-slate-blue" />
              </button>
              <div className="mx-auto relative lg:container overflow-y-auto max-h-[85vh] pt-2">
                {!loading && !submitted && (
                  <div className="space-y-8">
                    <div className="relative flex flex-row items-center justify-around mx-8" aria-hidden={true}>
                      <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-white opacity-20"></div>
                      <div
                        className={`${
                          step === 0 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        1
                      </div>
                      <div
                        className={`${
                          step === 1 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        2
                      </div>
                      <div
                        className={`${
                          step === 2 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        3
                      </div>
                      <div
                        className={`${
                          step >= 3 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        4
                      </div>
                    </div>

                    {step === 0 && (
                      <div className="mx-8 step_0" ref={pearsonRef}>
                        <div className="space-x-4 ">
                          {!target && searchResults.length === 0 && !searching && (
                            <div>
                              <span className="screen-reader-text" tabIndex={0}>
                                Etapa 1 de 4 para reconhecer colega em andamento.
                              </span>
                              <div className="relative flex-1">
                                <span tabIndex={0} className="text-alice-blue mb-3 block whitespace-nowrap text-base font-thin">
                                  Quem você gostaria de reconhecer?
                                </span>
                                <div className="space-x-4 flex flex-row items-center justify-between">
                                  <form onSubmit={handleSearch} className="pl-1 -ml-1 flex-1">
                                    <input
                                      type="text"
                                      aria-label="Campo de busca. Em braco. Campo editável"
                                      placeholder="Digite o nome ou a matrícula"
                                      style={{ fontSize: 16 }}
                                      className="w-full bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                                      ref={(ref: any) => {
                                        searchRef.current = ref;
                                      }}
                                      onChange={e => handleChange()}
                                    />
                                  </form>

                                  <TbSearch
                                    size={28}
                                    className="cursor-pointer hover:ring-2 mr-1 rounded-full"
                                    onClick={() => handleSearch()}
                                  />
                                </div>
                              </div>

                              {isEmpty && (
                                <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                                  <div className="text-center pt-2 text-white font-base font-light">
                                    Verifique a matrícula que você está buscando, essa matrícula não consta na base de funcionário
                                    do Joga Junto.
                                  </div>
                                </div>
                              )}

                              {!searching && searchResults.length === 0 && searched && (
                                <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl" key={'noResult'}>
                                  <div className="text-center pt-2 text-white font-base font-light">
                                    Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {searching && (
                            <>
                              <p className="animate-pulse text-white text-base font-thin p-3" tabIndex={0}>
                                Recuperando informações...
                              </p>
                            </>
                          )}

                          {!target && !!searchResults && searchResults.length > 0 && (
                            <div
                              className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl list-options"
                              ref={resultsRef}
                            >
                              {searchResults.map((item, index) => (
                                <button
                                  key={item._id}
                                  onClick={() => {
                                    sendPartialLog({ type: 'setTarget', data: item._id });
                                    setTarget(item);
                                  }}
                                  aria-label={`Selecionar ${item.name}. Chave ${item._id}. Lotado na ${item.extra?.dependencia}`}
                                  className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4 text-left`}
                                >
                                  <div className="w-[44px] h-[44px] ml-2" aria-hidden={true} tabIndex={-1}>
                                    <UserAvatar
                                      aria-hidden={true}
                                      data={{
                                        image: item.image,
                                        ariaHidden: false,
                                        ...item.extra,
                                      }}
                                    />
                                  </div>
                                  <p className="flex-1 pl-3 pr-2" aria-hidden={true} tabIndex={-1}>
                                    <span className="block text-base font-semibold">{item.extra?.nome_guerra}</span>
                                    <span className="block text-xs font-thin">
                                      {item.name} ({item._id})
                                    </span>
                                    <span className="block text-xs font-thin" aria-hidden={true}>
                                      <span className="text-electric-blue uppercase">{item.extra?.dependencia}</span> -{' '}
                                      {item.extra?.funcao}
                                    </span>
                                  </p>
                                </button>
                              ))}
                              <div className="text-center pt-2 text-white font-base font-light">
                                Não encontrou quem procura? Experimente buscar por nome e sobrenome, nome e diretoria ou
                                matrícula.
                              </div>
                            </div>
                          )}

                          {!!target && !searching && (
                            <div className="relative flex-1">
                              <h2 className="text-alice-blue mb-3 block whitespace-nowrap text-base font-thin" tabIndex={0}>
                                Você está reconhecendo:
                                <span className="screen-reader-text">
                                  {target.name}. Chave {target._id}. Lotado na {target.extra?.dependencia}
                                </span>
                              </h2>
                              <div className="flex-1 w-full flex flex-row items-center justify-between bg-rich-black bg-opacity-80 py-4 lg:px-8 rounded-3xl">
                                <div className="w-[44px] h-[44px] ml-2" aria-hidden={true}>
                                  <UserAvatar
                                    data={{
                                      image: target.image,
                                      ariaHidden: false,
                                      ...target.extra,
                                    }}
                                  />
                                </div>
                                <p className="flex-1 pl-3 pr-2" aria-hidden={true}>
                                  <span className="block text-base font-semibold">{target.extra?.nome_guerra}</span>
                                  <span className="block text-xs font-thin">
                                    {target.name} ({target._id})
                                  </span>
                                  <span className="block text-xs font-thin">
                                    <span className="text-electric-blue uppercase">{target.extra?.dependencia}</span> -{' '}
                                    {target.extra?.funcao}
                                  </span>
                                </p>

                                <RiCloseLine
                                  size={44}
                                  aria-label={'Excluir funcionário e voltar para campo de busca.'}
                                  tabIndex={0}
                                  className="cursor-pointer hover:ring-2 p-2 rounded-full text-slate-blue"
                                  onClick={() => {
                                    sendPartialLog({
                                      type: 'resetSearch',
                                      data: 'Excluir funcionário e voltar para campo de busca',
                                    });
                                    reset();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {step === 1 && (
                      <div className="block w-full step_1" ref={behaviorRef}>
                        <span className="screen-reader-text" tabIndex={0}>
                          Etapa 2 de 4 para reconhecer colega em andamento
                        </span>
                        <h2
                          className="block font-thin text-white text-base leading-none mb-5 px-5 lg:px-0  lg:mx-8"
                          aria-label={`Por qual comportamento você vai reconhecer ${
                            target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]
                          }`}
                          tabIndex={0}
                        >
                          Por qual comportamento você vai reconhecer{' '}
                          <strong className="text-electric-blue uppercase">
                            {target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]}
                          </strong>
                          ?
                        </h2>

                        <div
                          className={`${
                            behavior ? 'grid-items-reconhecer has-item' : 'grid-items-reconhecer'
                          } grid grid-cols-3 bg-oxford-blue-2 rounded-lg w-full p-4 lg:flex lg:flex-row items-center justify-between mt-5 text-xs lg:text-md`}
                        >
                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'setBehavior',
                                data: 'colaboracao',
                              });
                              setBehavior('colaboracao');
                            }}
                            tabIndex={0}
                            aria-label={`botão Colaboração ${behavior === 'colaboracao' ? 'selecionado' : ''} ${GetBehaviorDescription('colaboracao')} `}
                            className={`${
                              !behavior || behavior === 'colaboracao' ? '' : 'opacity-50'
                            } elem-1 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Colaboracao size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Colaboração</p>
                          </button>

                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'setBehavior',
                                data: 'inovacao',
                              });
                              setBehavior('inovacao');
                            }}
                            tabIndex={0}
                            aria-label={`botão Inovação ${behavior === 'inovacao' ? 'selecionado' : ''} ${GetBehaviorDescription('inovacao')}`}
                            className={`${
                              !behavior || behavior === 'inovacao' ? '' : 'opacity-50'
                            } elem-2 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Inovacao size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Inovação</p>
                          </button>

                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'setBehavior',
                                data: 'foco',
                              });
                              setBehavior('foco');
                            }}
                            tabIndex={0}
                            aria-label={`botão Foco no cliente ${behavior === 'foco' ? 'selecionado' : ''} ${GetBehaviorDescription('foco')}`}
                            className={`${
                              !behavior || behavior === 'foco' ? '' : 'opacity-50'
                            } elem-3 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <FocoNoCliente size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Foco no cliente</p>
                          </button>

                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'setBehavior',
                                data: 'resolutividade',
                              });
                              setBehavior('resolutividade');
                            }}
                            tabIndex={0}
                            aria-label={`botão Protagonismo ${behavior === 'resolutividade' ? 'selecionado' : ''} ${GetBehaviorDescription('resolutividade')}`}
                            className={`${
                              !behavior || behavior === 'resolutividade' ? '' : 'opacity-50'
                            } elem-4 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                          >
                            <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                              <Resolutividade size={'100%'} />
                            </div>
                            <p className="text-sm text-white m-0 p-0 font-thin">Protagonismo</p>
                          </button>

                          {target?.isLeader ? (
                            <button
                              onClick={() => {
                                sendPartialLog({
                                  type: 'setBehavior',
                                  data: 'lideranca',
                                });
                                setBehavior('lideranca');
                              }}
                              tabIndex={0}
                              aria-label={`botão Liderança Integradora ${behavior === 'lideranca' ? 'selecionado' : ''} ${GetBehaviorDescription('lideranca')}`}
                              className={`${
                                !behavior || behavior === 'lideranca' ? '' : 'opacity-50'
                              } elem-5 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Lideranca size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Liderança Integradora</p>
                            </button>
                          ) : null}

                          {!!behavior && (
                            <div
                              aria-hidden={true}
                              dangerouslySetInnerHTML={{
                                __html: GetBehaviorDescription(behavior),
                              }}
                              className="text-elem font-thin text-xs text-electric-blue block leading-tight"
                            ></div>
                          )}
                        </div>

                        <div className="bg-oxford-blue-2 lg rounded-lg w-full pb-4 md:hidden">
                          <div
                            className={`grid grid-cols-2 md:hidden gap-4  p-4 lg:flex-row items-center justify-between mt-5 text-xs lg:text-md`}
                          >
                            <button
                              onClick={() => {
                                sendPartialLog({
                                  type: 'setBehavior',
                                  data: 'colaboracao',
                                });
                                setBehavior('colaboracao');
                              }}
                              tabIndex={0}
                              aria-label={`botão Comportamento Colaboração ${behavior === 'colaboracao' ? 'selecionado' : ''}`}
                              className={`${
                                !behavior || behavior === 'colaboracao' ? '' : 'opacity-50'
                              } elem-1 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Colaboracao size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Colaboração</p>
                            </button>

                            <button
                              onClick={() => {
                                sendPartialLog({
                                  type: 'setBehavior',
                                  data: 'inovacao',
                                });
                                setBehavior('inovacao');
                              }}
                              tabIndex={0}
                              aria-label={`botão Comportamento Inovação ${behavior === 'inovacao' ? 'selecionado' : ''}`}
                              className={`${
                                !behavior || behavior === 'inovacao' ? '' : 'opacity-50'
                              } elem-2 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Inovacao size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Inovação</p>
                            </button>

                            <button
                              onClick={() => {
                                sendPartialLog({
                                  type: 'setBehavior',
                                  data: 'foco',
                                });
                                setBehavior('foco');
                              }}
                              tabIndex={0}
                              aria-label={`botão Comportamento Foco no cliente ${behavior === 'foco' ? 'selecionado' : ''}`}
                              className={`${
                                !behavior || behavior === 'foco' ? '' : 'opacity-50'
                              } elem-3 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <FocoNoCliente size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Foco no cliente</p>
                            </button>

                            <button
                              onClick={() => {
                                sendPartialLog({
                                  type: 'setBehavior',
                                  data: 'resolutividade',
                                });
                                setBehavior('resolutividade');
                              }}
                              tabIndex={0}
                              aria-label={`botão Comportamento Protagonismo ${behavior === 'resolutividade' ? 'selecionado' : ''}`}
                              className={`${
                                !behavior || behavior === 'resolutividade' ? '' : 'opacity-50'
                              } elem-4 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                            >
                              <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                <Resolutividade size={'100%'} />
                              </div>
                              <p className="text-sm text-white m-0 p-0 font-thin">Protagonismo</p>
                            </button>
                            {target?.isLeader ? (
                              <button
                                onClick={() => {
                                  sendPartialLog({
                                    type: 'setBehavior',
                                    data: 'lideranca',
                                  });
                                  setBehavior('lideranca');
                                }}
                                tabIndex={0}
                                aria-label={`Comportamento Liderança Integradora ${behavior === 'lideranca' ? 'selecionado' : ''}`}
                                className={`${
                                  !behavior || behavior === 'lideranca' ? '' : 'opacity-50'
                                } elem-5 ring-2 bg-maastricht-blue-2 flex-1 cursor-pointer ring-blue-violet-crayola p-2 pt-3 rounded-xl text-center flex flex-col items-center lg:max-w-[200px]`}
                              >
                                <div className="w-12 h-12 lg:w-16 lg:h-16 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-2">
                                  <Lideranca size={'100%'} />
                                </div>
                                <p className="text-sm text-white m-0 p-0 font-thin">Liderança Integradora</p>
                              </button>
                            ) : null}
                          </div>
                          {!!behavior && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: GetBehaviorDescription(behavior),
                              }}
                              className="text-elem font-thin text-xs text-electric-blue block leading-tight text-center px-5"
                            ></div>
                          )}
                        </div>
                      </div>
                    )}

                    {step === 2 && (
                      <div className="step_2" ref={recognitionRef}>
                        {!hasAnyRecognitionAvailable(balance, pointsSent) && (
                          <div>
                            <p className="text-yellow p-2 text-center border border-yellow rounded-lg lg:rounded-full mx-8">
                              Você não possui saldo de pontos para reconhecer. Aguarde até a próxima distribuição.
                            </p>
                          </div>
                        )}

                        {hasAnyRecognitionAvailable(balance, pointsSent) && (
                          <>
                            <h2
                              className="block font-thin text-white text-base leading-none mb-5 px-6 lg:px-0 lg:mx-8"
                              aria-label="Escolha o tipo de Reconhecimento que você deseja enviar:"
                              tabIndex={0}
                            >
                              Escolha o tipo de <strong>Reconhecimento</strong> que você deseja enviar para{' '}
                              <strong className="text-electric-blue uppercase">
                                {target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]}
                              </strong>{' '}
                              no comportamento{' '}
                              <strong className="text-electric-blue uppercase">{behavior ? BehaviorLabel[behavior] : ''}</strong>
                            </h2>

                            <div>
                              <div
                                className={`w-full ${
                                  !!coin ? 'grid-items-reconhecer has-item' : 'grid-items-reconhecer'
                                } moedas bg-oxford-blue-2 rounded-lg w-full py-4 px-8 lg:flex lg:flex-row items-center justify-between mt-5 text-xs lg:text-md text-yellow`}
                              >
                                <button
                                  disabled={coinIsBlocked('uau')}
                                  onClick={() => selectCoin('uau')}
                                  aria-label={`botão Reconhecimento UAU. ${coin === 'uau' ? 'selecionado' : ''} . ${coinCapLabel('uau')}. ${GetMoedaDescription('uau')}`}
                                  className={`${!coin || coin === 'uau' ? '' : 'opacity-50'} ${
                                    coinIsBlocked('uau') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-1 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col lg:flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin flex-1">
                                      <Uau size={20} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">#UAU</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {coinCapLabel('uau')}
                                  </p>
                                </button>
                                <button
                                  disabled={coinIsBlocked('mandou')}
                                  onClick={() => selectCoin('mandou')}
                                  aria-label={`botão Reconhecimento  Mandou Bem. ${coin === 'mandou' ? 'selecionado' : ''}. ${coinCapLabel(
                                    'mandou',
                                  )}.  ${GetMoedaDescription('mandou')}`}
                                  className={`${!coin || coin === 'mandou' ? '' : 'opacity-50'} ${
                                    coinIsBlocked('mandou') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-2 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col lg:flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin mandou flex-1">
                                      <MandouBem size={20} />
                                    </div>
                                    <div className="font-normal text-xs leading-tight text-white">#MANDOUBEM</div>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {coinCapLabel('mandou')}
                                  </p>
                                </button>
                                <button
                                  disabled={coinIsBlocked('valeu')}
                                  onClick={() => selectCoin('valeu')}
                                  aria-label={`botão Reconhecimento  Valeu. ${coin === 'valeu' ? 'selecionado' : ''}. ${coinCapLabel('valeu')}.  ${GetMoedaDescription('valeu')}`}
                                  className={`${!coin || coin === 'valeu' ? '' : 'opacity-50'} ${
                                    coinIsBlocked('valeu') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-3 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin flex-1">
                                      <Valeu size={20} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">#VALEU</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {coinCapLabel('valeu')}
                                  </p>
                                </button>

                                {!!coin && (
                                  <div
                                    aria-hidden={true}
                                    dangerouslySetInnerHTML={{
                                      __html: GetMoedaDescription(coin),
                                    }}
                                    className="text-elem font-thin text-xs text-electric-blue block leading-tight"
                                  ></div>
                                )}
                              </div>

                              {/* Painel proprio: a grade das moedas vira flex no lg e tem grid-areas
                                  fixas abaixo disso — o seletor nao cabe dentro dela sem quebrar as duas.
                                  `hidden md:block` espelha o breakpoint do `.grid-items-reconhecer` no SCSS. */}
                              {!!coin && (
                                <div className="hidden md:block bg-oxford-blue-2 rounded-lg w-full py-4 px-8 mt-5">
                                  <PointsPicker
                                    coin={coin}
                                    value={points}
                                    balance={balance}
                                    pointsSent={pointsSent}
                                    onChange={selectPoints}
                                  />
                                </div>
                              )}
                            </div>

                            <div className="lg:hidden">
                              <div
                                className={`w-full grid grid-cols-1 gap-y-4 moedas bg-oxford-blue-2 rounded-lg py-4 px-8 lg:flex lg:flex-row items-center justify-between mt-5 text-xs lg:text-md text-yellow`}
                              >
                                <button
                                  disabled={coinIsBlocked('uau')}
                                  onClick={() => selectCoin('uau')}
                                  className={`${!coin || coin === 'uau' ? '' : 'opacity-50'} ${
                                    coinIsBlocked('uau') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-1 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col lg:flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin flex-1">
                                      <Uau size={20} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">#UAU</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {coinCapLabel('uau')}
                                  </p>
                                </button>
                                <button
                                  disabled={coinIsBlocked('mandou')}
                                  onClick={() => selectCoin('mandou')}
                                  className={`${!coin || coin === 'mandou' ? '' : 'opacity-50'} ${
                                    coinIsBlocked('mandou') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-2 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-col lg:flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin mandou flex-1">
                                      <MandouBem size={20} />
                                    </div>
                                    <div className="font-normal text-xs leading-tight text-white">#MANDOUBEM</div>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {coinCapLabel('mandou')}
                                  </p>
                                </button>
                                <button
                                  disabled={coinIsBlocked('valeu')}
                                  onClick={() => selectCoin('valeu')}
                                  className={`${!coin || coin === 'valeu' ? '' : 'opacity-50'} ${
                                    coinIsBlocked('valeu') ? 'grayscale text-white' : ''
                                  } disabled:opacity-50 elem-3 ring-2 bg-maastricht-blue-2 cursor-pointer ring-blue-violet-crayola p-3 rounded-xl text-center inline-flex flex-col justify-center items-center`}
                                >
                                  <div className="flex flex-row items-center lg:space-x-2 mb-3">
                                    <div className="coin flex-1">
                                      <Valeu size={20} />
                                    </div>
                                    <p className="font-normal text-xs leading-tight text-white">#VALEU</p>
                                  </div>
                                  <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                                    {coinCapLabel('valeu')}
                                  </p>
                                </button>

                                {!!coin && (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: GetMoedaDescription(coin),
                                    }}
                                    className="text-elem font-thin text-xs text-electric-blue block leading-tight"
                                  ></div>
                                )}
                              </div>

                              {!!coin && (
                                <div className="bg-oxford-blue-2 rounded-lg w-full py-4 px-8 mt-5">
                                  <PointsPicker
                                    coin={coin}
                                    value={points}
                                    balance={balance}
                                    pointsSent={pointsSent}
                                    onChange={selectPoints}
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {step === 3 && target && behavior && coin && (
                      <div className="bg-oxford-blue-2 rounded-lg w-full py-4 px-8 block step_3" ref={feedbackRef}>
                        <h2
                          className="block font-thin text-white text-base leading-none mb-3"
                          aria-label={` Agora conte a ${
                            target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]
                          } o motivo de ganhar ${GetMoedaLabel(coin).replace('#', 'hashtag')} em ${GetBehaviorLabel(behavior)}`}
                          tabIndex={0}
                        >
                          Agora conte a{' '}
                          <strong className="uppercase">
                            {target?.extra?.nome_guerra ? target?.extra?.nome_guerra : target?.name?.split(' ')[0]}
                          </strong>{' '}
                          o motivo de ganhar <span className="text-electric-blue">{GetMoedaLabel(coin)}</span> em{' '}
                          <span className="text-electric-blue">{GetBehaviorLabel(behavior)}</span>!
                        </h2>
                        <div className="flex flex-row items-center">
                          <div className="h-48 w-full bg-transparent">
                            <TextEditor
                              initialValue={message}
                              onChange={handleChangeMessage}
                              minLength={minTextLength}
                              maxLength={maxTextLength}
                            />
                          </div>
                        </div>

                        {messageLength && messageLength.fullLength > 0 && messageLength.textLength < minTextLength && (
                          <p className="text-yellow mt-5" tabIndex={0}>
                            Para continuar, insira pelo menos {minTextLength} caracteres no campo de texto, sem contar os emojis.
                          </p>
                        )}

                        {messageLength && messageLength.fullLength > 0 && messageLength.fullLength > maxTextLength && (
                          <p className="text-yellow mt-5" tabIndex={0}>
                            O texto inserido ultrapassou o limite máximo de {maxTextLength} caracteres.
                          </p>
                        )}

                        <div className="text-yellow flex items-start space-x-2 mt-5">
                          <AiOutlineWarning size={30} />
                          <p className="text-white">
                            Todos os reconhecimentos que você enviar ficarão visíveis aos outros participantes. #Ética e
                            Integridade são as bases da confiança.
                          </p>
                        </div>
                      </div>
                    )}

                    {step === 4 && target && behavior && coin && points !== undefined && (
                      <div className="space-y-6 ">
                        <div className="text-yellow flex items-center space-x-2 pr-2">
                          <span className="block w-[30px] flex-1">
                            <AiOutlineWarning size={30} className="flex-1" />
                          </span>
                          <p className="text-white">
                            Depois de enviar o reconhecimento, você ainda poderá cancelar nos próximos 15 minutos. Além disso, é
                            possível editar ou solicitar a devolução ao destinatário até 10 dias após o envio (seus pontos só
                            serão estornados até o final do mês do envio). Deseja enviar esse reconhecimento?
                          </p>
                        </div>

                        <div className="bg-oxford-blue-2 rounded-lg w-full py-4 px-8 block step_4">
                          <div className="bg-maastricht-blue-3 rounded-xl text-gray-300 space-y-2 py-6 px-6 lg:px-8">
                            <div className="flex flex-col lg:flex-col items-start lg:items-start mb-5">
                              <div className="flex-1 flex flex-col-reverse lg:flex-row items-start space-x-2 leading-tight w-full">
                                <div className="flex flex-1 w-full items-start">
                                  {user && (
                                    <div className="mr-2">
                                      <UserAvatar
                                        data={{
                                          image: target.image,
                                          ...target.extra,
                                        }}
                                      />
                                    </div>
                                  )}
                                  <div className="flex-1 w-full block">
                                    <a
                                      href={`https://humanograma.intranet.bb.com.br/${target._id}`}
                                      target="_blank"
                                      tabIndex={0}
                                      rel="noreferrer"
                                      aria-label={`Você enviou para: ${
                                        target?.extra?.nome_guerra || target.name.split(' ')[0]
                                      }. Chave ${target?._id}. Lotado ${target.extra?.diretoria} ${
                                        CoinLabel[coin]
                                      } ${BehaviorLabel[behavior].replace('#', 'hashtag')} um total de ${points} pontos`}
                                      className="w-fit  hover:text-white"
                                    >
                                      <Tippy
                                        allowHTML={true}
                                        content={
                                          <>
                                            <p className="m-0">
                                              Nome: <strong>{target?.name}</strong>
                                            </p>
                                            <p className="m-0">
                                              Função: <strong>{target?.extra?.funcao}</strong>
                                            </p>
                                            <p className="m-0">
                                              Diretoria: <strong>{target?.extra?.diretoria}</strong>
                                            </p>
                                            <p className="m-0 mt-2 text-electric-blue">Clique para o Humanograma</p>
                                          </>
                                        }
                                      >
                                        <div className="w-fit block text-sm lg:text-base text-alice-blue font-thin">
                                          VOCÊ enviou para: <br />
                                          <span className="font-semibold">
                                            {target?.extra?.nome_guerra || target.name.split(' ')[0]}
                                          </span>{' '}
                                          ({target?._id})
                                          <BiInfoCircle className="inline relative -top-[2px] ml-1" />
                                        </div>
                                      </Tippy>
                                    </a>

                                    <div>
                                      <span className="block text-xs font-thin">
                                        <span className="text-electric-blue uppercase">{target.extra?.diretoria}</span> -{' '}
                                        {target.extra?.prefixo} -{' '}
                                        <span className="text-electric-blue">{target.extra?.funcao} </span>
                                      </span>
                                    </div>

                                    <div className="block 2xl:flex flex-col 2xl:flex-row 2xl:items-center w-full space-y-2 2xl:space-y-0 2xl:space-x-2 mt-1">
                                      <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full">
                                        {Coins[coin]} <span className="text-xs">{CoinLabel[coin]}</span>
                                      </div>
                                      <br className="block 2xl:hidden" />
                                      <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full">
                                        {Behaviors[behavior]} <span className="text-xs">{BehaviorLabel[behavior]}</span>
                                      </div>
                                      <>
                                        <br className="block 2xl:hidden" />
                                        <div className="inline-flex items-center space-x-2">
                                          <div
                                            className={`ring-white whitespace-nowrap 2xl:mt-0 flex-1 2xl:flex-none inline-flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-electric-blue rounded-full`}
                                          >
                                            <span>total = {points} pontos</span>{' '}
                                          </div>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <hr className="border-prussian-blue" />

                            <>
                              <div className="p-2 flex-1 flex-col">
                                <div className="flex justify-between mb-3">
                                  <p className="text-electric-blue font-thin">Reconhecimento enviado:</p>
                                </div>
                                {!!message && (
                                  <div
                                    className="text-alice-blue break-words"
                                    tabIndex={0}
                                    aria-label="Texto do reconhecimento enviado"
                                    dangerouslySetInnerHTML={{
                                      __html: convertEmojis(message),
                                    }}
                                  />
                                )}
                              </div>
                            </>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="flex justify-center flex-col items-center space-y-6">
                      <div className="p-2 px-45 flex flex-row space-x-8 items-center justify-center">
                        {isRecoveredDraft && !isLoadingPartialRecognition && (target || behavior || coin || message) && (
                          <button
                            onClick={async () => {
                              await clearPartialRecognition();
                              reset();
                              setIsRecoveredDraft(false);
                            }}
                            aria-label="Limpar rascunho salvo e começar do início"
                            className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <BsTrash size={18} className="mr-2" />
                            <p className="font-bold text-sm leading-none uppercase">Limpar rascunho</p>
                          </button>
                        )}

                        {step === 0 && !target && !!searchResults && searchResults.length > 0 && (
                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'back',
                                location: 'bottom',
                                data: 'reset',
                              });

                              reset();
                            }}
                            className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                          </button>
                        )}

                        {step > 0 && (
                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'back',
                                location: 'bottom',
                                data: 'setStep(' + (step - 1) + ')',
                              });

                              setStep(step - 1);
                            }}
                            aria-label={`Voltar para etapa ${step} de reconhecimento`}
                            className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                          </button>
                        )}

                        {step < 3 && (
                          <button
                            disabled={
                              (step === 0 && !target) ||
                              (step === 1 && !behavior) ||
                              (step === 2 && (!coin || points === undefined)) ||
                              (step === 3 && !message)
                            }
                            onClick={() => {
                              sendPartialLog({
                                type: 'next',
                                location: 'bottom',
                                data: 'setStep(' + (step + 1) + ')',
                              });

                              setStep(step + 1);
                            }}
                            aria-label={`Continuar e ir para etapa ${step + 1}. Habilitado`}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Continuar</p>
                          </button>
                        )}

                        {step === 3 && (
                          <>
                            <button
                              disabled={
                                !message ||
                                !messageLength ||
                                messageLength.textLength < minTextLength ||
                                messageLength.fullLength > maxTextLength
                              }
                              onClick={() => {
                                sendPartialLog({
                                  type: 'review',
                                  location: 'bottom',
                                  data: 'setStep(' + (step + 1) + ')',
                                });

                                setStep(step + 1);
                              }}
                              aria-label={`Revisar reconhecimento`}
                              className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                            >
                              <p className="font-bold text-sm leading-none uppercase">Revisar</p>
                            </button>
                          </>
                        )}

                        {step === 4 && (
                          <button
                            disabled={
                              !message ||
                              !messageLength ||
                              messageLength.textLength < minTextLength ||
                              messageLength.fullLength > maxTextLength
                            }
                            onClick={() => handleSubmit()}
                            aria-label={`Enviar reconhecimento`}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Enviar</p>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {loading && !submitted && (
                  <div className="space-y-4 mt-12">
                    <div className="flex flex-row items-center justify-center text-xl text-yellow animate-pulse">
                      <div></div>
                      Enviando reconhecimento...
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}

          {submitted && (
            <ModalAcessivel isOpen={submitted} onRequestClose={() => setIsOpen(false)}>
              <div
                className="border-2 rounded-3xl relative bg-oxford-blue border-electric-blue p-8 flex flex-col w-[324px] lg:max-w-screen-md justify-center items-center"
                ref={feedbackServer}
                tabIndex={0}
              >
                <button
                  className="absolute -top-5 -right-5 button-close"
                  tabIndex={0}
                  aria-label="Fechar modal de feedback"
                  onClick={() => {
                    sendPartialLog({ type: 'close', location: 'submitted' });

                    setIsOpen(false);
                  }}
                >
                  <IoMdCloseCircle size={48} className="text-slate-blue" />
                </button>

                <div className="flex flex-col items-center justify-center">
                  {!hasSubmitError && (
                    <>
                      <div className="flex items-center justify-center mb-6">
                        <img
                          src={getImgFeedback(coin || '')}
                          alt={coin === 'mandou' ? 'Mandou bem!' : coin === 'uau' ? 'Uau!' : 'Valeu!'}
                          className="w-[173px] block"
                        />
                      </div>
                      <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                        {coin === 'mandou' ? 'Mandou bem!' : coin === 'uau' ? 'Uau!' : 'Valeu!'}
                      </h1>
                      <p className="text-sm font-white font-light text-center block" tabIndex={0}>
                        {submitMessage}
                      </p>
                    </>
                  )}

                  {hasSubmitError && (
                    <>
                      <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                        Não foi possível enviar o reconhecimento!
                      </h1>
                      <p className="text-sm font-white font-light text-center block mb-8" tabIndex={0}>
                        {submitMessage}
                      </p>
                      {showRetryButton() && (
                        <button
                          onClick={() => {
                            sendPartialLog({ type: 'retry', location: 'submitted' });
                            // reset();
                            setStep(3);
                            setHasSubmitError(false);
                            setSubmitted(false);
                          }}
                          tabIndex={0}
                          className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                        >
                          Tentar novamente
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </ModalAcessivel>
          )}

          {showModalAlert && (
            <ModalAlert
              description={showModalAlert}
              descriptionHtml={modalAlertHtml}
              isWarning={isWarning}
              onClose={() => {
                setShowModalAlert(false);
                setModalAlertHtml(undefined);
              }}
            />
          )}

          {showModalItem && (
            <Modal
              onClose={clear => {
                setshowModalItemItem(false);
                if (clear) {
                  setTarget(undefined);
                }
              }}
            />
          )}
        </ModalAcessivel>
      )}
    />
  );
}
